function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// DEPRECATED COMPONENT, DO NOT USE. USE APP-COMPONENTS EventTracker INSTEAD.

import axios from 'axios';
import _ from 'lodash';
import { getSlimUser } from "../user/getSlimUser";
import getSlimGroup from "./getSlimGroup";
function eventCreatedAt() {
  return Math.floor(new Date().getTime() / 1000);
}

/**
 * @visibleName EventTracker DEPRECATED
*/
var EventTracker = /*#__PURE__*/function () {
  function EventTracker() {
    _classCallCheck(this, EventTracker);
  }
  return _createClass(EventTracker, null, [{
    key: "trackClick",
    value: function trackClick(eventName, payload, config) {
      var group = getSlimGroup(config);
      var user = getSlimUser(_.get(config, 'user', {}), group);
      var url = _.get(config, 'url', null);
      if (!url) {
        console.error('EventTracker.trackClick track url undefined.');
      }
      var data = {
        event: {
          name: eventName,
          created_at: eventCreatedAt()
        },
        payload: payload,
        user: user,
        group: group
      };
      function onSuccess() {
        return true;
      }
      function onError(error) {
        throw error;
      }
      var request = axios.post("".concat(url, "/events"), data);
      return request.then(onSuccess, onError);
    }
  }]);
}();
export { EventTracker as default };